<template>
  <div class="row">
    <div class="col-12">
      <form @submit.prevent="save" ref="user_form">
        <div class="form-group">
          <label>Nome completo <span class="text-danger">*</span></label>
          <input
            type="text"
            v-model="user.name"
            class="form-control"
            placeholder="Nome completo"
          />
        </div>

        <div class="form-group row">
          <div class="col-lg-6">
            <label>E-mail <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="user.email"
              class="form-control"
              placeholder="E-mail"
            />
          </div>

          <div class="col-lg-6">
            <label>Perfil <span class="text-danger">*</span></label>
            <select
              v-model="user.user_profile_id"
              @change="changeUserProfile"
              class="form-control"
            >
              <option
                v-for="user_profile in user_profiles"
                :key="user_profile.id"
                :value="user_profile.id"
              >
                {{ user_profile.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-6">
            <label>Senha <span class="text-danger">*</span></label>
            <input
              type="password"
              v-model="user.password"
              class="form-control"
              placeholder="Senha"
            />
          </div>

          <div class="col-lg-6">
            <label>Confirmação de senha <span class="text-danger">*</span></label>
            <input
              type="password"
              v-model="user.password_confirmation"
              class="form-control"
              placeholder="Confirmação de senha"
            />
          </div>
        </div>

        <div class="form-group" v-if="!isAllCompaniesAllowedUserProfile">
          <label>Empresas</label>
          <MultiSelect
            v-model="user.companies"
            :options="companies"
            :filter="true"
            option-label="name"
            option-value="id"
            placeholder="Selecione ou pesquise"
            class="w-100"
          />
        </div>

        <div class="form-group row">
          <div class="col-lg-6">
            <label>Cargo</label>
            <input
              type="text"
              v-model="user.occupation"
              class="form-control"
              placeholder="Cargo"
            />
          </div>

          <div class="col-lg-6">
            <label>Setor</label>
            <input
              type="text"
              v-model="user.office"
              class="form-control"
              placeholder="Setor"
            />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-6">
            <label>RG</label>
            <input
              type="text"
              v-model="user.rg"
              class="form-control"
              placeholder="RG"
            />
          </div>

          <div class="col-lg-6">
            <label>CPF</label>
            <input
              type="text"
              v-model="user.cpf"
              class="form-control"
              placeholder="CPF"
            />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-6">
            <label>Situação</label>
            <select v-model="user.active" class="form-control">
              <option value="1">Ativo</option>
              <option value="0">Inativo</option>
            </select>  
          </div>

          <div class="col-lg-6">
            <label>Gerenciar frentes de trabalho?</label>
            <select v-model="user.work_front_manager" class="form-control">
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        </div>

        <input name="id" type="hidden" v-model="user.id" />

        <div class="row mt-2">
          <div class="col-6">
            <button class="btn btn-success" type="button" @click="openTable()">
              <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
              Voltar para a listagem
            </button>
          </div>
          <div class="col-6 d-flex flex-row-reverse">
            <button 
              class="btn btn-primary"
              :disabled="!user.user_profile_id || !user.name || !user.email || !user.password || !user.password_confirmation"
            >
              <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
              {{ submit_text }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  import MultiSelect from 'primevue/multiselect'

  import useCompanies from '@/modules/Company.js'
  import useUserProfiles from '@/modules/UserProfile.js'
  import useUsers from '@/modules/User.js'
  import useSwal from '@/modules/Swal.js'

  export default {
    components: {
      MultiSelect,
    },
    setup() {
      const route = useRoute()
      const router = useRouter()

      const { companies, listCompanies } = useCompanies()
      const { user_profiles, listUserProfiles } = useUserProfiles()
      const { getUser, saveUser } = useUsers()

      const { showSuccessDialog, showErrorDialog } = useSwal()

      const allCompaniesAllowedUserProfiles = ['Admin', 'Engenheiro', 'Técnico']

      return {
        route,
        router,
        companies,
        user_profiles,
        getUser,
        saveUser,
        listCompanies,
        listUserProfiles,
        allCompaniesAllowedUserProfiles,
        showSuccessDialog,
        showErrorDialog,
      }
    },
    data() {
      return {
        loading: true,
        user_form: null,
        isAllCompaniesAllowedUserProfile: false,
        user: {
          id: null,
          user_profile_id: null,
          name: '',
          rg: '',
          cpf: '',
          email: '',
          password: '',
          password_confirmation: '',
          occupation: '',
          office: '',
          active: '',
          work_front_manager: '',
          companies: [],
        },
        submit_text: '',
      }
    },
    methods: {
      async load() {
        await this.listCompanies(1, 100)
        await this.listUserProfiles()

        if (this.route.params.id) {
          await this.getUser(this.route.params.id).then((response) => {
            this.user = response.data.data
            this.user.companies = this.user.companies.map(
              (company) => company.id,
            )
          })

          this.submit_text = 'Salvar alterações'
        } else {
          this.submit_text = 'Cadastrar'
        }

        this.loading = false
        this.changeUserProfile()
      },
      save() {
        const app = this

        this.saveUser(this.user)
          .then(() => {
            this.showSuccessDialog()

            setTimeout(() => {
              app.$router.push('/users')
            }, 500)
          })
          .catch(() => {
            this.showErrorDialog()
          })
      },
      openTable() {
        this.router.push('/users');
      },
      changeUserProfile() {
        const userProfile = this.user_profiles.filter(user => user.id == this.user.user_profile_id)[0]
        this.isAllCompaniesAllowedUserProfile = this.allCompaniesAllowedUserProfiles.includes(userProfile?.name)
        
        if (this.isAllCompaniesAllowedUserProfile) {
          this.user.companies = []
        }
      }
    },
    mounted() {
      this.load()
    }
  }
</script>
